interface FaqData {
  title: string;
  faq_arr?: Array<{
    question: string;
    answer: string;
    qustion?: string;
  }>;
  data_array?: Array<{
    question: string;
    answer: string;
    qustion?: string;
  }>;
}

interface StaticFaqAccordionProps {
  faqData: FaqData;
  className?: string;
  containerClassName?: string;
  titleClassName?: string;
}

export default function StaticFaqAccordion({
  faqData,
  className = '',
  containerClassName = 'px-[14px] py-[32px] lg:px-[100px] xl:px-[224px] xl:py-[50px] 2xl:px-[448px] 2xl:pt-[57px] 2xl:pb-[72px]',
  titleClassName = 'font-bb text-[20px] leading-[24px] text-center xl:text-[36px] xl:leading-[44px] 2xl:text-[48px] 2xl:leading-[58px] text-primary-text border-b border-[#D4D4D4] pb-[21px] xl:pb-[24px] 2xl:pb-[28px]',
}: StaticFaqAccordionProps) {
  const faqList = faqData?.data_array || faqData?.faq_arr || [];

  if (!faqList.length) {
    return null;
  }

  return (
    <div className={`w-full fixed bottom-0 left-0 -translate-x-[100%] ${className}`}>
      <div className={containerClassName}>
        <div>
          <h3 className={titleClassName} dangerouslySetInnerHTML={{ __html: faqData.title }} />

          <dl className="space-y-[0px]">
            {faqList.map((item, index) => (
              <div
                key={index}
                className="border-b border-[#D4D4D4] pb-[16px] lg:pb-[24px] 2xl:pb-[24px] pt-[16px]"
              >
                <dt>
                  <h4
                    className="font-bb text-[14px] xl:text-[16px] leading-[17px] xl:leading-[19px] pr-[10px] lg:text-[16px] lg:leading-[19px] 2xl:text-[16px] 2xl:leading-[19px] text-primary-text lg:pr-[16px] 2xl:pr-[16px]"
                    // ! 后端字段名有误，需求兼容
                    dangerouslySetInnerHTML={{ __html: item.question || item.qustion }}
                  />
                </dt>
                <dd className="pt-[10px]">
                  <h4
                    className="font-ir text-[12px] xl:text-[14px] leading-[18px] xl:leading-[18px] pr-[18px] xl:pr-[24px]"
                    dangerouslySetInnerHTML={{ __html: item.answer }}
                  />
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
